import React, { useContext } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import PublicIcon from "@mui/icons-material/Public";
import { useMapMode, useUpdateMapMode } from "../../../utils/router";
import { MapMode } from "../../../context/MapContext";
import { AssignmentsTab } from "./AssignmentsTab";
import { SystemwideTab } from "./SystemwideTab";
import { PageContext } from "../../../context/PageContext";

const getTab = (mode: MapMode, mobile: boolean) => {
  if (mode === "assignments") return <AssignmentsTab mobile={mobile} />;
  if (mode === "view") return <SystemwideTab mobile={mobile} />;
  {
    /* if (mode === "edit") return <EditTab mobile={mobile} />; */
  }
  return null;
};

export const MapSidebar: React.FC<{ mobile?: boolean }> = ({ mobile }) => {
  const mode = useMapMode();
  const content = useContext(PageContext);
  const updateMode = useUpdateMapMode();
  return (
    <Box
      sx={{
        position: "relative",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {!mobile ? (
        <Tabs
          value={mode ?? "assignments"}
          onChange={(_, value) => updateMode(value as MapMode)}
          variant="fullWidth"
          sx={{ position: "sticky", top: 0 }}
        >
          <Tab
            icon={<HomeIcon />}
            label="Your assignments"
            value={"assignments"}
          />
          <Tab icon={<PublicIcon />} label="Systemwide" value={"view"} />
          {/*<Tab icon={<EditIcon />} label="Edit" value={"edit"} />*/}
        </Tabs>
      ) : null}
      <Box
        sx={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          overflow: "hidden",
          pb: { md: 10 },
        }}
      >
        <Box
          sx={{
            px: { xs: 2, md: 2 },
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            flex: 10,
          }}
        >
          <Typography
            sx={{
              textAlign: "left",
              mt: 0,
              mb: 1,
              fontSize: ".875rem",
              fontStyle: "italic",
            }}
          >
            {content[`${mode}_descriptions`]}
          </Typography>
          {getTab(mode, mobile)}
        </Box>
      </Box>
    </Box>
  );
};
